import React, { useRef, useState } from "react"
import Title from "./title"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

// Styles
import styles from "../styles/components/gallery.module.scss"
import { FaFacebookF, FaInstagram } from "react-icons/fa"

const Gallery = () => {
  const dialog = useRef(null)
  const [selected, setSelected] = useState(null)

  const data = useStaticQuery(graphql`
    query {
      image1: file(relativePath: { eq: "gallery-lifetime-fitness-1.png" }) {
        childImageSharp {
          fluid(maxWidth: 1650, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      image2: file(relativePath: { eq: "gallery-lifetime-fitness-2.png" }) {
        childImageSharp {
          fluid(maxWidth: 800, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      image3: file(relativePath: { eq: "gallery-lifetime-fitness-3.png" }) {
        childImageSharp {
          fluid(maxWidth: 800, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      image4: file(relativePath: { eq: "gallery-lifetime-fitness-4.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      image5: file(relativePath: { eq: "gallery-lifetime-fitness-5.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      image6: file(relativePath: { eq: "gallery-lifetime-fitness-6.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <div className={styles.main} id="gallery">
      <Title text="Image Gallery" />
      <div className={styles.grid}>
        {Object.values(data).map(({ childImageSharp }, index) => (
          <button className={styles.thumbnail} key={index} type="button" aria-label={`Enlarge gallery photo ${index + 1}`} onClick={() => { setSelected(childImageSharp.fluid); dialog.current.showModal() }}>
            <Img fluid={childImageSharp.fluid} alt={`Lifetime Fitness gym gallery photo ${index + 1}`} style={{ width: "100%" }} />
          </button>
        ))}
      </div>
      <dialog ref={dialog} className={styles.lightbox} aria-label="Enlarged gallery photo" onClick={event => { if (event.target === event.currentTarget) dialog.current.close() }}>
        <button className={styles.close} type="button" aria-label="Close gallery photo" onClick={() => dialog.current.close()}>×</button>
        {selected && <img src={selected.srcWebp || selected.src} alt="Enlarged Lifetime Fitness gallery photo" />}
      </dialog>
      <div className={styles.footer}>
        <p>Follow Us</p>
        <a
          aria-label="Lifetime Fitness on Facebook"
          href="https://www.facebook.com/Lifetime-Fitness-422919781093919/"
          rel="nofollow"
        >
          <FaFacebookF />
        </a>
        <a
          aria-label="Lifetime Fitness on Instagram"
          href="https://www.instagram.com/lifetime.fitness.by.maduranga/"
          rel="nofollow"
        >
          <FaInstagram />
        </a>
      </div>
    </div>
  )
}

export default Gallery
